import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// _mock
import { _addressBooks } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import FormProvider, { RHFSelect } from 'src/components/hook-form';
//
import CreateEditMaterial from './create-edit-material';
import { Box, Button, DialogActions, Divider, MenuItem } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { useData } from 'src/contexts/gantt-chart/gantt-context';
import { LoadingScreen } from 'src/components/loading-screen';
import { dateformation2 } from 'src/components/date-format-mdy';
import { handleErrorMessages } from 'src/components/risk-management/risk-register/feching';
import { useSnackbar } from 'notistack';
import { postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
// ----------------------------------------------------------------------

export default function Material({gantt, close, selectedDate }) {
  const router = useRouter();
  const { dateWiseMaterials, dateWiseMaterialsLoading, getDateWiseMaterials,refreshAssignData } = useData();
  useEffect(() => {
    getDateWiseMaterials(dateformation2(selectedDate));
  }, [selectedDate]);
  console.log(dateWiseMaterials, 'tmsa na janna q ooooooo');
  const loadingSave = useBoolean();
  const { enqueueSnackbar } = useSnackbar();

  const loadingSend = useBoolean();
  const [loading, setLoading] = useState(false);
  const NewInvoiceSchema = Yup.object().shape({});

  const defaultValues = useMemo(
    () => ({
      start_date: selectedDate,
      activity: '',
      category: [
        // {
        //   category_name: '',
        //   items: [
        //     {
        //       code: '',
        //       description: '',
        //       quantity: '',
        //       unit: '',
        //       type: '',
        //       availablity: '',
        //       locationType: '',
        //       location: '',
        //     },
        //   ],
        // },
      ],
    }),
    []
  );

  const methods = useForm({
    resolver: yupResolver(NewInvoiceSchema),
    defaultValues,
  });

  const {
    reset,
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleSaveAsDraft = handleSubmit(async (data) => {});

  const handleCreateAndSend = handleSubmit(async (data) => {
    setLoading(true);
    const category = [];
    data.category.map((item) => {
      let assigned_material = [];
      item.items.map((mat) => {
        assigned_material.push({
          performance_material_id: mat.code,
          quantity: mat.quantity,
          availability: mat.availablity,
          location_type: mat.locationType,
          location: mat.location,
        });
      });
      category.push({
        id: item.category_name,
        assigned_material,
      });
    });
    const dataForApi = {
      assignable_id: data.activity,
      assignable_type: 'App\\PlannedCostCode',
      category,
    };

    try {
      const response = await postRequest(
        `${endpoints.ganttChart.assign_materials}?date=${dateformation2(selectedDate)}`,
        dataForApi,
        false
      );
      console.log(response);
      if (response.metadata && response.metadata.success) {
        const refreshData= await refreshAssignData();
             gantt.parse(refreshData);
        close();
        await getDateWiseMaterials(dateformation2(selectedDate));
        reset();
        enqueueSnackbar({
          variant: 'success',
          message: 'Material has been assigned successfully.',
        });
        return;
      }
      if (!(response.metadata && response.metadata.success)) {
        throw new Error(response?.message || 'Failed to assign');
      }
    } catch (err) {
      console.error('Error:', err);
      handleErrorMessages(err.message || 'Submission failed.');
      return err.message;
    } finally {
      setLoading(false);
    }
  });

  return dateWiseMaterialsLoading ? (
    <Box height={300} mb={5}>
      <LoadingScreen />
    </Box>
  ) : (
    <FormProvider methods={methods}>
      <Box
        gap={3}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(3, 1fr)',
          lg: 'repeat(3, 1fr)',
        }}
      >
        <Controller
          name="start_date"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <DatePicker
              disabled
              label="Start Date"
              value={field.value}
              onChange={(newValue) => {
                field.onChange(newValue);
              }}
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                  error: !!error,
                  helperText: error?.message,
                },
              }}
            />
          )}
        />

        <RHFSelect
          onChange={(e) => {
            setValue('activity', e.target.value);
            const selectedActivity = dateWiseMaterials?.activities?.find(
              (item) => item.id == e.target.value
            );
            if (
              selectedActivity.assigned_material &&
              selectedActivity.assigned_material.length > 0
            ) {
              let arr = [];
              selectedActivity.assigned_material.map((subItem) => {
                let metrial = subItem.assigned_material;
                let arr2 = [];
                if (metrial && metrial.length > 0) {
                  metrial.map((item) => {
                    arr2.push({
                      code: item?.performance_material_id,
                      description: item?.performance_material?.name,
                      quantity: item?.quantity,
                      unit: item?.performance_material?.unit,
                      type: item?.performance_material?.type,
                      availablity: item?.availability,
                      locationType: item?.location_type,
                      location: item.location,
                    });
                  });
                } else {
                  arr2.push({
                    code: '',
                    description: '',
                    quantity: '',
                    unit: '',
                    type: '',
                    availablity: '',
                    locationType: '',
                    location: '',
                  });
                }
                arr.push({
                  category_name: subItem.id,
                  items: arr2,
                });
              });
              setValue('category', arr);
            } else {
              setValue('category', [
                {
                  category_name: '',
                  items: [
                    {
                      code: '',
                      description: '',
                      quantity: '',
                      unit: '',
                      type: '',
                      availablity: '',
                      locationType: '',
                      location: '',
                    },
                  ],
                },
              ]);
            }
          }}
          size="small"
          name="activity"
          label="Activity"
        >
          {dateWiseMaterials?.activities?.map((service) => (
            <MenuItem key={service.id} value={service.id}>
              {service.description}
            </MenuItem>
          ))}
        </RHFSelect>
      </Box>
      <Divider sx={{ marginTop: '20px', marginBottm: '20px' }} />
      <CreateEditMaterial />
      <DialogActions sx={{ paddingRight: '0px' }}>
        <Button
          variant="outlined"
          onClick={() => {
            close();
          }}
          className="danager"
        >
          Cancel
        </Button>
        <LoadingButton loading={loading} variant="contained" onClick={handleCreateAndSend}>
          Submit
        </LoadingButton>
      </DialogActions>
    </FormProvider>
  );
}

Material.propTypes = {
  currentInvoice: PropTypes.object,
};
